import { JsonPathLabelType, JsonNodeType, jsonPathLabels, JsonNodeBasicType } from './config';

// 根据field label判断节点类型
function getNodeType(node, label: string): JsonNodeType {
  const labelType = getJsonPathLabelType(label);
  switch (getBasicType(node)) {
    case JsonNodeBasicType.V_OBJECT:
      if (labelType === JsonPathLabelType.JsonPathLabelType_Map) {
        return JsonNodeType.JsonNodeType_Map;
      } else if (labelType === JsonPathLabelType.JsonPathLabelType_Array) {
        return JsonNodeType.JsonNodeType_Null;
      }
      return JsonNodeType.JsonNodeType_Object;
    case JsonNodeBasicType.V_ARRAY:
      if (labelType === JsonPathLabelType.JsonPathLabelType_Array) {
        return JsonNodeType.JsonNodeType_Array;
      }
      return JsonNodeType.JsonNodeType_Null;
    case JsonNodeBasicType.V_STRING:
      // 去除空格、换行、tab
      const v = node.replace(/[\n\t\r\s]/g, '');
      if (
        (labelType === JsonPathLabelType.JsonPathLabelType_Array && v.startsWith('[') && v.endsWith(']')) ||
        (v.startsWith('{') && v.endsWith('}'))
      ) {
        return JsonNodeType.JsonNodeType_JsonString;
      }
      return JsonNodeType.JsonNodeType_Null;
    default:
      return JsonNodeType.JsonNodeType_Null;
  }
}

// 获取节点基本数据类型
function getBasicType(node): JsonNodeBasicType {
  switch (Object.prototype.toString.call(node)) {
    case '[object Object]':
      return JsonNodeBasicType.V_OBJECT;
    case '[object Array]':
      return JsonNodeBasicType.V_ARRAY;
    case '[object String]':
      return JsonNodeBasicType.V_STRING;
    default:
      return JsonNodeBasicType.V_OTHER;
  }
}

// 根据field label获取子节点
function getNodeByPath(node, path: string) {
  return node[path];
}

// 获取field label类型
function getJsonPathLabelType(label: string): JsonPathLabelType {
  return jsonPathLabels[label] ?? JsonPathLabelType.JsonPathLabelType_Normal;
}

// 根据field生成path数组
function genValidPaths(path: string, separator = '::'): string[] {
  return path.split(separator);
}

export { getNodeType, getBasicType, getNodeByPath, getJsonPathLabelType, genValidPaths };
